import { render, staticRenderFns } from "./Scl.vue?vue&type=template&id=33465ea1&scoped=true"
import script from "./Scl.vue?vue&type=script&lang=js"
export * from "./Scl.vue?vue&type=script&lang=js"
import style0 from "./Scl.vue?vue&type=style&index=0&id=33465ea1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33465ea1",
  null
  
)

export default component.exports